import React from 'react'
import { validators } from '../../utils/helpers/validators'
import SaveButton from '../common/buttons/SaveButton'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'

const GeneralForm = ({ inputs, handleChange, handleSubmit }) => {
  const validateForm = validators.hasValue(inputs?.name)

  return (
    <div className="general-form-container">
      <div className="modal-content-wrapper">
        <LabeledText
          autoFocus
          idLabel="name"
          required
          name="name"
          value={inputs?.name}
          type="text"
          onChange={(e) => handleChange(e)}
        />
        <LabeledText
          idLabel="description"
          required
          name="description"
          value={inputs?.description}
          type="text"
          onChange={(e) => handleChange(e)}
        />
      </div>
      <div className="modal-btn-container">
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => handleSubmit()}
          isDisabled={!validateForm}
        />
      </div>
    </div>
  )
}

export default GeneralForm
